<template>
	<div class="main situation" v-loading="loading">
		<div class="crumb" v-if="crumbList&&crumbList.length">
			<span v-for="(item,index) in crumbList" class="crumb_item" :key="index" @click="closeMask"><a href="javascript:;">{{item}}</a></span>
			<span class="order_list" style="display: flex;">
				<span class="crumb_item bg_eee" :class="{activeCrumb: item.recordNo == baseInfo.recordNo}" v-for="(item,index) in myAccidentList" :key="('accidentList_'+index)" @click="reStartMask(item.id)">
					{{item.recordNo}}
					<img src="../../assets/images/icon/home_tab_icon_close.png" alt="" class="close_img" @click.stop="doCancel(item.id,index)">
				</span>
			</span>
			<span class="jumpBtn">
				<div class="myJumpBtn" @click="setScrollTop(0)">基本信息</div>
				<div class="myJumpBtn" @click="setScrollTop(1)">现场违法照片</div>
				<div class="myJumpBtn" @click="setScrollTop(2)">当事人信息</div>
				<div class="myJumpBtn" v-if="baseInfo.transportWay != 3" @click="setScrollTop(3)">车辆信息</div>
				<div class="myJumpBtn" @click="setScrollTop(4)">文书生成</div>
			</span>
		</div>
		<div style="height: 100%;">
			<div class="leftContent input_new_style" :class="[fullVideo ? 'fullVideoClass_left' : 'original_left']">
				<el-collapse v-model="activeName_a">
					<el-collapse-item title="基本信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>执法处理地点</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.organizationId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in daduiLists" :key="`${item.id}_xwdd`" :label="item.fullName" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>执法处理单位</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.handleOrganizationId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in daduiLists" :key="`${item.id}_gzdw`" :label="item.fullName" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>经办人1</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.firstOperatorId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in userLists" :key="`${item.id}_xwr1`" :label="item.realname" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>经办人2</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.secondOperatorId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in userLists" :key="`${item.id}_xwr2`" :label="item.realname" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>执法处理时间</div>
										</div>
										<div class="right h32">
											<el-date-picker v-model="baseInfo.handleTime" type="datetime" :disabled="disabled_edit" placeholder="选择日期"></el-date-picker>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>交通方式</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.transportWay" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.trafficLists" :key="`${item.value}`" :label="item.title" :value="item.value"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>执法地点</div>
										</div>
										<div class="right h32">
											<el-input style="width: 60%;" placeholder="请输入" v-model="baseInfo.location" :disabled="disabled_edit"></el-input>
											<span style="display: flex; align-items: center; margin-left: 20px;" @click="showMap">
                                            	<i class="icon_address"></i>
											</span>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法地址</div>
										</div>
										<div class="right h32">
											<el-autocomplete style="width: 48%; margin-right: 2%;" placeholder="请输入内容" v-model="baseInfo.firstRoadName" :fetch-suggestions="((e, cb) => {getRoadCode(e, cb, 1)})" @select="handleSelect($event, 1)" :disabled="disabled_edit"></el-autocomplete>
											<el-autocomplete style="width: 48%;" placeholder="请输入内容" v-model="baseInfo.secondRoadName" :fetch-suggestions="((e, cb) => {getRoadCode(e, cb, 2)})" @select="handleSelect($event, 2)" :disabled="disabled_edit"></el-autocomplete>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法行为</div>
										</div>
										<div class="right h32">
											<el-autocomplete placeholder="请输入内容" v-model="autocomplete_value" :fetch-suggestions="((e, cb) => {getRoadCode(e, cb, 3)})" @select="handleSelect($event, 3)" :disabled="disabled_edit"></el-autocomplete>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>执法人</div>
										</div>
										<div class="right h32">{{baseInfo.realName}}</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>执法时间</div>
										</div>
										<div class="right h32">{{baseInfo.createTime}}</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_e">
					<el-collapse-item title="现场违法照片" name="1">
						<div class="retrun_case">
							<img class="retrun_image" v-if="driverCardFrontImage" :src="getImageUrl(driverCardFrontImage) + '&time=' + new Date().getTime()" @click="previewImg(driverCardFrontImage)">
							<img class="retrun_image" v-if="driverCardBackImage" :src="getImageUrl(driverCardBackImage) + '&time=' + new Date().getTime()" @click="previewImg(driverCardBackImage)">
							<img class="retrun_image" v-if="vehicleCardImage" :src="getImageUrl(vehicleCardImage) + '&time=' + new Date().getTime()" @click="previewImg(vehicleCardImage)">
							<img class="retrun_image" v-if="idCardImage" :src="getImageUrl(idCardImage) + '&time=' + new Date().getTime()" @click="previewImg(idCardImage)">
							<template v-for="(item, index) in otherImages">
								<img class="retrun_image" :key="index" v-if="item" :src="getImageUrl(item) + '&time=' + new Date().getTime()" @click="previewImg(item)">
							</template>
							<!-- <template v-if="certificateFileUrl">
								<img class="retrun_image rotate_image" v-for="(item, index) in certificateFileUrl" :key="index" :src="getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()" @click="previewImg(item.certificateImage)">
							</template>
							<template v-else-if="signFileImage">
								<template v-for="(item, index) in signFileImage">
									<img class="retrun_image rotate_image" v-if="item.certificateImage != null" :key="index" :src="getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()" @click="previewImg(item.certificateImage)">
								</template>
							</template> -->
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_b">
					<el-collapse-item title="当事人信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>姓名</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.partyName" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>联系方式</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.telephone" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>驾驶证/身份证号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.cardCode" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>现住详细地址</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.address" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49" v-if="baseInfo.transportWay == 2">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>发证机构</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.issuingAuthority" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>准驾车型</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.carClassId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.driList" :key="item.CODE" :label="item.CODE" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49" v-if="baseInfo.transportWay == 2">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>驾驶证档案编号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.archivesCode" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>车牌号码</div>
										</div>
										<div class="right h32">
											<el-select style="width: 120px; margin-right: 10px;" placeholder="请选择" v-model="car_title" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="(item, index) in tempList.liceList" :key="index" :label="item.name" :value="item.name"></el-option>
											</el-select>
											<el-input placeholder="请输入" v-model="car_number" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49" v-if="baseInfo.transportWay == 2">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>证件地址</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.cardAddress" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>备注</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.remark" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49" v-if="baseInfo.transportWay == 1">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>职业</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.job" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.staList" :key="item.id" :label="item.name" :value="item.name"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>所属公司</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.company" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49" v-if="baseInfo.transportWay != 2">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>是否有异议</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.hasDissent" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.dissentLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>备注</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.remark" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_c" v-if="baseInfo.transportWay != 3">
					<el-collapse-item title="车辆信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>车牌号码</div>
										</div>
										<div class="right h32">
											<el-select style="width: 120px; margin-right: 10px;" placeholder="请选择" v-model="car_title" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="(item, index) in tempList.liceList" :key="index" :label="item.name" :value="item.name"></el-option>
											</el-select>
											<el-input placeholder="请输入" v-model="car_number" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>号牌种类</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.plateTypeId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.flaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>车辆类型</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.vehicleTypeId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.vehList" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column" v-if="baseInfo.transportWay == 1">
										<div class="left">
											<div>车辆购买地</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.buyCarAddress" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<!-- <el-collapse v-model="activeName_d">
					<el-collapse-item title="上传文书" name="1">
						<template slot="title">
							<div style="width: 100%; display: flex; justify-content: space-between;">
								<span>
									上传文书
								</span>
								<span style="margin-right: 30px;" v-if="!disabled_edit">
									<el-button type="primary" size="mini" @click.stop="addScan(7)">新增当事人文书</el-button>
									<el-button type="primary" size="mini" @click.stop="addScan(10)">新增备份文书</el-button>
								</span>
							</div>
						</template>
						<div class="wholeAcccindentClass">
							<div class="accidentImages">
								<div class="images" v-for="(item, index) in clericalFiles" :key="index">
									<div class="img-box" v-if="item.penaltiesImage">
										<img class="rotate_image" :src="getImageUrl(item.penaltiesImage)" />
										<div class="img-mask">
											<i class="el-icon-delete" v-if="!disabled_edit" @click="deleteImg(index, item.ucode)"></i>
											<i class="el-icon-zoom-in" @click="previewImg(item.penaltiesImage)"></i>
										</div>
									</div>
									<div class="img-box" v-else>
										<div class="img-mask-no">
											<div style="display: flex;" v-if="!disabled_edit">
												<i class="el-icon-folder-add" style="position: relative; margin-right: 20px; font-size: 30px; overflow: hidden;">
													<input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg(item.type, index, item, $event)" />
												</i>
												<i class="el-icon-printer" style="font-size:30px;" @click="statrScan(index, item)"></i>
											</div>
											<div>{{item.type == 7 ? "当事人文书" : "备份文书"}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="wholeAcccindentClass" style="margin-top: 25px; display: none;">
								<dwt :is_scan="is_scan" :roomId="roomId" :is_ucode="is_ucode" :is_type="is_type" @changeScanState="changeScanState"></dwt>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse> -->
				<el-collapse v-model="activeName_f">
					<el-collapse-item  title="文书生成" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>处罚类型</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="signParams.type" :disabled="disabled_edit" @change="onSetType">
												<el-option v-for="item in tempList.punishLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>文书编号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="signParams.fileNo" :disabled="disabled_edit" @change="onSetFileNo"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required" v-if="signParams.type == 1">*</i>处罚金额</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" type="number" v-model="signParams.price" :disabled="disabled_edit" @change="onSetPrice"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-200">
								 <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div>文书描述</div>
                                        </div>
                                        <div class="right">
                                            <el-input placeholder="请输入" type="textarea" maxlength="600" resize="none" show-word-limit v-model="signContent" :disabled="disabled_edit"></el-input>
                                        </div>
                                    </div>
                                </div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<div style="width: 100%; height: 66px;"></div>
				<div style="display:none;">
					<!-- <template v-if="certificateFileUrl">
						<div ref="print">
							<img class="retrun_image" style="width:100%; height:auto;" v-for="(item, index) in certificateFileUrl" :key="index" :src="getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()">
						</div>
					</template> -->
					<template>
						<div ref="print">
							<img class="retrun_image" style="width:100%; height:auto;" :src="getImageUrl(printFileUrl) + '&time=' + new Date().getTime()">
						</div>
					</template>
				</div>
			</div>

			<div class="rightContent" :class="{ fullVideoClass_right: fullVideo }">
				<!--左边成员列表名单-->
				<div class="left">
					<div v-if="videoBtnShow" class="videoBtnZone">
						<span id="myBtnCase2" v-if="!disabled_edit">
							<el-button type="success" v-if="remoteStatus == 'success' && !hasLocal" v-preventReClick="5000" @click="getRoom">视频呼叫</el-button>
							<el-button type="danger" v-if="remoteStatus == 'danger' && !list.length" v-preventReClick="5000" @click="notInRoom">视频呼叫</el-button>
						</span>
					</div>
					<span v-show="videoState == 0" class="display-flex-between—new" style="margin-top: 478px;">
						<div id="warp myLocal" class="userlist local" :class="[myTempIndex === null ? myMainVideo : '']" v-if="localStream" @click="switchLocalMain1($event)">
							<div id='local_stream'>
								<div class="role1" v-if="list.length" @click.stop="muteLocalAudio">
									<img class="policeMuteClass" :src="isAudio ? require('../../assets/images/pics/icon_microphone2_sel.png') : require('../../assets/images/pics/icon_microphone2_nor.png')">
									<span>交警</span>
								</div>
								<!-- <div class="role2" v-if="list.length">
                                    <img src="../../assets/images/pics/icon_video_open.png" class="myIcon" v-if="list.length > 0 && !isShow" @click.stop="onChangeView" />
                                    <img src="../../assets/images/pics/icon_video_close.png" class="myIcon" v-if="list.length > 0 && isShow" @click.stop="onChangeView" />
                                </div> -->
							</div>
							<div id='mask' class="maskable" v-show="!isVedio"></div>
						</div>
						<div id="warp" class="userlist bg-white remote police" v-if="list.length && showPolice">
							交警
						</div>
						<div class="userlist remoteClass remote user" v-for="(item,index) in list" :key="item.id" :class="[myTempIndex === index ? myMainVideo : '']">
							<div :id="item.id" class="distant-stream" v-html="item.remoteStream" v-if="item.remoteStream"></div>
						</div>
					</span>
					<!--远端流-->
					<div class="display-flex margin-top-15">
						<div class="myBtn" v-if="!videoBtnShow" @click="leaveRoom">
							<img src="../../assets/images/pics/icon_hang_up.png" alt="">
							<div class="">
								挂断
							</div>
						</div>
						<!-- <div class="myBtn" v-if="!videoBtnShow" @click="snapRemote">
							<img class="jt" src="../../assets/images/pics/call_button_instrument.png" alt="">
							<div class="">
								截图
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="bottomBtns">
			<el-button type="primary" v-if="!disabled_edit" @click="previewSignBook">预览文书</el-button>
			<el-button type="primary" v-if="!disabled_edit" @click="pushSignBook">推送文书</el-button>
			<el-button type="primary" @click="seeSignBook">查看文书</el-button>
			<el-button type="primary" v-if="!disabled_edit" @click="printSignBook">打印文书</el-button>
			<el-button type="primary" @click="sendSignBook">发送文书</el-button>
			<el-button type="danger" v-if="!disabled_edit" @click="stopHandle">处置终止</el-button>
			<el-button type="success" v-if="!disabled_edit" @click="onFinish">全流程完成</el-button>
			<el-button plain @click="showVideos">查看视频</el-button>
			<!-- <el-button plain @click="saveTemp">暂存</el-button> -->
			<el-button plain @click="closeMask">返回</el-button>
			<!-- <div class="hang_up_btn" v-if="!videoBtnShow" @click="leaveRoom">
				<img src="../../assets/images/pics/icon_hang_up.png" alt="">
			</div> -->
		</div>

		<transition name="el-zoom-in-center">
			<MapMask v-if="mapShow" :lng="lng" :lat="lat" @hideMap="hideMap"></MapMask>
		</transition>
		<transition name="el-zoom-in-center">
			<Pdf v-if="padShow" :pdfUrl="pdfUrl" @hidePdf="hidePdf"></Pdf>
		</transition>
		<transition name="el-zoom-in-center">
			<Videos v-if="videos_state" :videoJson="videoJson" @hideVideo="hideVideo"></Videos>
		</transition>
		<transition name="el-zoom-in-center">
			<Send v-if="sendState" :sendPhoneStr="userInfos.telephone" :id="roomId" @hideSend="hideSend"></Send>
		</transition>
	</div>
</template>

<script>
	import LibGenerateTestUserSig from "../../../static/js/lib-generate-test-usersig.min.js";
	import $ from "../../../static/js/jquery-3.2.1.min.js";
	import TRTC from "trtc-js-sdk";
	import config from "@/common/env.js";
	import { mapState } from "vuex";
	import dwt from "./components/dwt"
	import MapMask from "./components/mapMask"
	import Pdf from "./components/pdf"
	import Videos from "./components/videos.vue"
	import Send from "./components/send.vue"
	import tempList from "./json/index.js"

	export default {
		props: ["roomId", "videoDirect", "videoSource", ],
		name: "videoPlat",
		components: {
			dwt,
			MapMask,
			Pdf,
			Videos,
			Send,
		},
		data() {
			return {
				// ---------- new data ----------
				loading: false,
				activeName_a: ["1"],
				activeName_b: ["1"],
				activeName_c: ["1"],
				activeName_d: ["1"],
				activeName_e: ["1"],
				activeName_f: ["1"],
				daduiLists: [],
				userLists: [],
				baseInfo: {},
				userInfos: {},

				driverCardFrontImage: null,
				driverCardBackImage: null,
				vehicleCardImage: null,
				idCardImage: null,
				otherImages: [],
				autocomplete_value: null,

				penaltiesImage: null,

				signFileImage: null, // 全流程完成，文书返回凭证
				certificateFileUrl: null, // 轮训文书返回凭证
				is_scan: false,
				key_scan: 1,
				clericalFiles: [ //上传文书对象
					{
						penaltiesImage: null,
						certificateImage: null,
						ucode: this.get_guid(),
						type: 7,
					},
					{
						penaltiesImage: null,
						certificateImage: null,
						ucode: this.get_guid(),
						type: 10,
					}
				],
				is_ucode: null,
				is_type: null,
				is_index: null,

				disabled_edit: false,
				tempList: tempList,
				car_title: config.configuration.carRegion,
				car_number: null,

				// -------------------- old data --------------------

				// ***** 音视频data start *****
				myTempIndex: 0,
				remoteUserStatus: false,
				muteMeObj: {},
				margin0: "margin0",
				tempKey: {},
				showPolice: true,
				hasLocal: false,
				fullVideo: false,
				list: [], // 远端流列表
				client: "", // 客户端服务
				remoteStream: "", // 远方播放流
				localStream: "", // 本地流,
				isVedio: true, // 当前是否打开摄像头
				isAudio: true, // 当前是否打开麦克风
				members_: new Map(), // 成员
				isHave: false, //当前列表是否有该成员
				stream: null,
				newStream: null,
				videoBtnShow: true,

				myMainVideo: "myMainVideo",
				userId: "",

				// ***** 音视频data end *****

				noSave: false,
				id: null,
				usePart: null,
				nowId: "",
				userItemInterval: null,
				videoState: 0, //-1代表默认;0代表微信;1代表支付宝
				isShowView: false,
				disabled_btn: false,

				mapShow: false,
				lng: null,
				lat: null,
				textLists: [],

				signParams: {
					recordId: this.roomId,
					type: null,
					fileNo: null,
					price: null,
					content: null,
				},
				signContent: null,
				printFileUrl: null,
				padShow: false,
				pdfUrl: null,
				videos_state: false,
				videoJson: {},
				sendState: false,

			}
		},
		watch: {
			myTempIndex(newVal, oldVal) {
				console.log(newVal)
				if (newVal == 0 || newVal) {
					if (this.list.length == 1) {
						let local = document.getElementById('local_stream');
						local.classList.add('margin0');
					} else {
						$("#local_stream").removeClass('margin0');
					}
				}
			},

		},
		computed: {
			...mapState(['command', 'myAccidentList']),

			crumbList() {
				return this.$route.meta.crumbList;
			},
			isShow() {
				let isShowView = this.isShowView || sessionStorage.getItem('isShowView');
				if (isShowView == 'true' || isShowView == true) {
					return true;
				} else if (isShowView == 'false' || isShowView == false) {
					return false;
				} else {
					return false;
				}
			},
			remoteStatus() {
				return this.remoteUserStatus ? "success" : "danger";
			},

		},
		beforeMount() {
			var beginTime = 0; //执行onbeforeunload的开始时间
			var differTime = 0; //时间差
			let that = this;
			window.onunload = function() {
				differTime = new Date().getTime() - beginTime;
				if (differTime <= 5) {
					console.log("浏览器关闭")
					that.saveTemp();
				} else {
					console.log("浏览器刷新")
					// that.saveTemp();
				}
			}
			window.onbeforeunload = function() {
				beginTime = new Date().getTime();
			}

		},
		created() {
			this.getDaduiLists();
			this.getUserLists();

		},
		mounted() {
			window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))

			let that = this;
			window.muteMyVideo = this.muteMyVideo;
			window.muteMyAudio = this.muteMyAudio;
			window.stopMyVideo = this.stopMyVideo
			window.snapMyVideo = this.snapMyVideo;
			window.kickPerson = this.kickPerson;
			window.goTop = this.goTop;

			this.myLoopMethod();
			clearInterval(this.userItemInterval);
			this.userItemInterval = setInterval(() => {
				that.myLoopMethod();
			}, 4000)

			this.getNewDetail();
		},
		beforeDestroy() {
			console.log("卸载")
			if (!this.noSave) {
				this.saveTemp();
			}
			window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))

			this.leaveRoom();
			clearInterval(this.userItemInterval);
		},
		methods: {
			// ---------- new methods ----------
			// 获取大队列表
			getDaduiLists() {
				this.$axios.get(`/admin/organization/childrenList/parent-41`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.daduiLists = data;
					}
				})
			},
			// 经办人
			getUserLists() {
				let id = JSON.parse(localStorage.getItem("userinfos")).organizationId || null;
				this.$axios.get(`/admin/organization/users/${id}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.userLists = data;
					}
				})
			},
			// 道路代码 and 违法代码
			getRoadCode(e, cb, n) {
				// console.log(e)
				// console.log(n)
				if(n == 1) {
					this.$axios.post(`/admin/enforcement/${1}/roadList`, {
						level: 1,
						name: e,
						parentCode: null,
					}).then((res) => {
						let data = this.AppUtils.checkResponse(res);
						if (data.code == 0) {
							this.textLists = data.data;
							this.textLists.map(item => {
								item.value = item.roadName;
							})
							cb(this.textLists);
							this.$forceUpdate();
						}
					})
				} else if(n == 2) {
					this.$axios.post(`/admin/enforcement/${2}/roadList`, {
						level: 2,
						name: e,
						parentCode: this.baseInfo.firstRoadCode,
					}).then((res) => {
						let data = this.AppUtils.checkResponse(res);
						if (data.code == 0) {
							this.textLists = data.data;
							this.textLists.map(item => {
								item.value = item.roadName;
							})
							cb(this.textLists);
							this.$forceUpdate();
						}
					})
				} else if(n == 3) {
					this.$axios.post(`/admin/enforcement/illegalList`, {
						name: e
					}).then((res) => {
						let data = this.AppUtils.checkResponse(res);
						if (data.code == 0) {
							this.textLists = data.data;
							this.textLists.map(item => {
								item.value = item.illegalInfo;
							})
							cb(this.textLists);
							this.$forceUpdate();
						}
					})
				}
			},
			handleSelect(e, n) {
				// console.log(e)
				// console.log(n)
				if(n == 1) {
					this.baseInfo.firstRoadName = e.value;
					this.baseInfo.firstRoadId = e.id;
					this.baseInfo.firstRoadCode = e.roadCode;
					this.baseInfo.secondRoadName = null;
					this.baseInfo.secondRoadId = null;
				} else if(n == 2) {
					this.baseInfo.secondRoadName = e.value;
					this.baseInfo.secondRoadId = e.id;
				} else if(n == 3) {
					this.baseInfo.illegalCodeIds = [{
						illegalInfo: e.value,
						illegalCodeId: e.id,
						illegalCode: e.illegalCode,
						firstClause: e.firstClause,
						secondClause: e.secondClause,
					}]
				}
				this.setSignContent(this.signParams.type, this.baseInfo, this.signParams.price);
			},


			showMap() {
				this.mapShow = true;
				this.lng = this.baseInfo.lng || 116.397128;
				this.lat = this.baseInfo.lat || 39.916527;
			},
			hideMap() {
				this.mapShow = false;
			},


			// 详情
			getNewDetail() {
				this.$axios.get(`/admin/enforcement/detail/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.userId = data.baseInfo.videoUserId;
						if(data.baseInfo.status >= 3) {
							this.disabled_edit = true;
							clearInterval(this.userItemInterval);
						} else {
							this.disabled_edit = false;
						}

						this.baseInfo = Object.assign({}, this.baseInfo, data.baseInfo);
						this.lng = data.baseInfo.lng;
						this.lat = data.baseInfo.lat;
						this.autocomplete_value = data.baseInfo.illegalCodeIds.length > 0 ? data.baseInfo.illegalCodeIds[0].illegalInfo : null;

						this.userInfos = Object.assign({}, data.userInfos[0]);
						let plateNo = data.userInfos[0].carPlate || "";
						let plateFirst = data.baseInfo.transportWay == 3 ? "" : plateNo.substring(0, 1) || config.configuration.carRegion;
						let plateSecond = plateNo.substring(1) || "";
						this.car_title = plateFirst;
						this.car_number = plateSecond;

						this.driverCardFrontImage = data.driverCardFrontImage;
						this.driverCardBackImage = data.driverCardBackImage;
						this.vehicleCardImage = data.vehicleCardImage;
						this.idCardImage = data.idCardImage;
						this.otherImages = data.otherImages;

						this.signParams = data.clericalInfo == null ? this.signParams : Object.assign({}, this.signParams, data.clericalInfo);
						this.signContent = data.clericalInfo == null ? null : data.clericalInfo.content;

						this.videoJson = data.videos;

						if(data.baseInfo.status >= 3) {
							this.signFileImage = data.clericalFiles;
						}
						if(data.clericalFiles && data.clericalFiles.length > 0) {
							this.clericalFiles = data.clericalFiles;
						}
					}
				})
			},

			// 选择处罚类型
			onSetType(e) {
				// console.log(e)
				this.setSignContent(e, this.baseInfo, this.signParams.price);
			},
			// 填写文书编号
			onSetFileNo(e) {
				console.log(e)
			},
			// 填写处罚金额
			onSetPrice(e) {
				console.log(e)
				if(e <= 0) {
					this.signParams.price = null;
					return this.$message.error("请输入大于0的数字");
				}
				this.setSignContent(this.signParams.type, this.baseInfo, e);
			},

			// 文书内容拼接
			setSignContent(type, datas, num) {
				let str = "";
				let date = datas.handleTime.split(" ");
				let one = date[0].split("-");
				let two = date[1].split(":");
				let time = `${one[0]}年${parseInt(one[1])}月${parseInt(one[2])}日${parseInt(two[0])}时${parseInt(two[1])}分`;
				let new_address = `${datas.firstRoadName}${datas.secondRoadName == null ? "" : datas.secondRoadName}`;
				let common_str = `　　被处罚人于${time}，在${new_address}实施${datas.illegalCodeIds[0].illegalInfo}违法行为（代码${datas.illegalCodeIds[0].illegalCode}），违反了${datas.illegalCodeIds[0].firstClause}的规定，根据${datas.illegalCodeIds[0].secondClause}之规定：\n　　`;
				let common_str2 = `\n　　如不服本决定，可以在收到本决定书之日起60日内向所在地本级人民政府申请行政复议；或者在6个月内向违法行为发生地人民法院提起行政诉讼。`;
				let common_str3 = `\n　　处罚前已口头告知违法行为人拟作出处罚的事实、理由和依据，并告知违法行为人依法享有陈述权和申辩权。`;
				if(type == 1) {
					let one_str_1 = `决定给予：${this.digitUppercase(num)}（¥${num == null ? 0 : num}）罚款。`;
					let one_str_2 = `\n　　持本决定书在15日内到指定的银行缴纳罚款。逾期不缴纳的，每日按罚款数额的3%加处罚款，加处罚款的数额不超过罚款本数。`;

					str = `${common_str}${one_str_1}${one_str_2}${common_str2}${common_str3}`;
				} else if(type == 2) {
					let two_str_1 = `决定处以警告处罚`;

					str = `${common_str}${two_str_1}${common_str2}${common_str3}`;
				}
				
				this.signContent = str;
				this.signParams.content = this.signContent;
			},

			// 数字转化为大写金额
			digitUppercase(n) {
				var fraction = ["角", "分"];
				var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
				var unit = [
					["元", "万", "亿"],
					["", "拾", "佰", "仟"],
				];
				var head = n < 0 ? "欠" : "";
				n = Math.abs(n);
				var s = "";
				for (var i = 0; i < fraction.length; i++) {
					s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, "");
				}
				s = s || "整";
				n = Math.floor(n);
				for (var i = 0; i < unit[0].length && n > 0; i++) {
					var p = "";
					for (var j = 0; j < unit[1].length && n > 0; j++) {
						p = digit[n % 10] + unit[1][j] + p;
						n = Math.floor(n / 10);
					}
					s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
				}
				return (head +s.replace(/(零.)*零元/, "元").replace(/(零.)+/g, "零").replace(/^整$/, "零元整"))
			},

			hidePdf() {
				this.pdfUrl = null;
				this.padShow = false;
			},

			// 预览文书
			previewSignBook() {
				if(this.signParams.type == null) {
					return this.$message.error("请选择处罚类型");
				} else if(this.signParams.fileNo == null) {
					return this.$message.error("请输入文书编号");
				} else if(this.signParams.type == 1 && this.signParams.price == null) {
					return this.$message.error("请输入处罚金额");
				}
				this.signParams.content = this.signContent;
				console.log(this.signParams)
				let { recordId, type, fileNo, price, content } = this.signParams
				let params = {
					recordId,
					type,
					fileNo,
					price,
					content,
				}
				console.log(params)
				// this.loading = true;
				this.$axios.post(`/admin/enforcement/preview/clerical`, params).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					this.loading = false;
					if (code == 0) {
						this.$message.success("预览文书成功");
						// this.previewImg(data, "preview");
						this.pdfUrl = data;
						this.padShow = true;
					} else {
						this.$message.error(msg);
					}
				}).catch(err => {
					this.loading = false;
				})
			},

			// 推送文书
			pushSignBook() {
				this.$axios.get(`/admin/enforcement/push/sign/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("推送文书成功");
						// this.getNewDetail();
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 查看文书
			seeSignBook() {
				// if(this.certificateFileUrl == null) return this.$message.error("文书未签字！");
				// this.previewImg(this.certificateFileUrl[0].certificateImage, "type");
				this.$axios.get(`/admin/enforcement/view/clerical/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("查看文书成功");
						// this.previewImg(data, "preview");
						this.pdfUrl = data;
						this.padShow = true;
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 打印文书
			printSignBook() {
				// if(this.certificateFileUrl == null) return this.$message.error("文书未签字！");
				// let options = { style: "no" }
				// this.$print(this.$refs.print, options);
				let _this = this;
				this.$axios.get(`/admin/enforcement/view/clerical/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						// this.printFileUrl = data;
						// setTimeout(() => {
						// 	let options = { style: "no" }
						// 	_this.$print(_this.$refs.print, options);
						// }, 1000)
						this.pdfUrl = data;
						this.padShow = true;
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 发送文书
			sendSignBook() {
				this.sendState = true;
			},
			hideSend() {
				this.sendState = false;
			},

			// 处置终止
			stopHandle() {
				this.$confirm('确定处置终止, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.get(`/admin/enforcement/stop/${this.roomId}`).then(res => {
						let datas = this.AppUtils.checkResponse(res);
						let { code, data, msg } = datas;
						if (code == 0) {
							this.noSave = true;
							this.$message.success("处置终止成功");
							this.getStartMethods();
						} else {
							this.$message.error(msg);
						}
					})
				}).catch(() => {

				})
			},

			// 全流程完成
			onFinish() {
				this.$confirm('确定全流程处置完成？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					this.$axios.get(`/admin/enforcement/finish/${this.roomId}`).then(res => {
						let datas = this.AppUtils.checkResponse(res);
						let { code, data, msg } = datas;
						if (code == 0) {
							this.noSave = true;
							this.$message.success("全流程完成成功");
							this.getStartMethods();
						} else {
							this.$message.error(msg);
						}
					})
				}).catch(() => {

				})
			},

			// 查看视频
			showVideos() {
				console.log(this.videoJson)
				this.videos_state = true;
			},
			hideVideo() {
				this.videos_state = false;
			},

			// 扫描仪
			statrScan(index, item) {
				this.is_ucode = item.ucode;
				this.is_type = item.type;
				this.is_index = index;
				this.is_scan = true;
			},
			changeScanState(val) {
				console.log("scan=>", val)
				if (val.state) {
					this.clericalFiles[this.is_index].penaltiesImage = val.url;
					this.$forceUpdate();
					this.is_scan = false;
				} else {
					this.key_scan = this.key_scan++;
					this.is_scan = false;
				}
			},

			addScan(type) {
				let json = {
					penaltiesImage: null,
					certificateImage: null,
					ucode: this.get_guid(),
					type: type
				}
				this.clericalFiles.push(json);
			},

			get_guid() {
				function S4() {
					return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
				}
				return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
			},

			// 图片上传
			updateImg(usePart, index, item, e) {
				let file = e.target.files[0];
				console.log(usePart)
				console.log(file)
				console.log(index)
				console.log(item)
				this.getUploadInfo(file, usePart, index, item);
			},
			getUploadInfo(file, usePart, index, item) {
				let formData = new FormData();
				formData.append("file", file);
				formData.append("uCode", item.ucode);
				formData.append("type", usePart);
				formData.append("recordId", this.roomId);

				this.$axios.post(`/admin/enforcement/upload/penalties`, formData).then(res => {
					console.log(res)
					let { code, data, msg } = res.data;
					if (code == 0) {
						if (usePart == 5) {

						} else if (usePart == 6) {

						} else if (usePart == 7) {
							this.clericalFiles[index].penaltiesImage = data.url;
							this.$forceUpdate();
						} else if (usePart == 10) {
							this.clericalFiles[index].penaltiesImage = data.url;
							this.$forceUpdate();
						}
					} else {
						this.$message.error(msg);
					}
				})

			},
			getImageUrl(url, type) {
				let str = type ? "/file/server/file" : "/file/server/decrypt/file";
				return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
			},
			previewImg(url, type) {
				let data = [];
				if(this.driverCardFrontImage != null) {
					data.push(this.driverCardFrontImage)
				}
				if(this.driverCardBackImage != null) {
					data.push(this.driverCardBackImage)
				}
				if(this.vehicleCardImage != null) {
					data.push(this.vehicleCardImage)
				}
				if(this.idCardImage != null) {
					data.push(this.idCardImage)
				}
				if(this.otherImages.length > 0) {
					data = data.concat(this.otherImages)
				}
				if (this.clericalFiles != null && this.clericalFiles.length > 0) {
					this.clericalFiles.forEach(item => {
						if(item.penaltiesImage != null) {
							data.push(item.penaltiesImage)
						}
					})
				}
				
				if(this.disabled_edit) {
					if (this.signFileImage != null) {
						this.signFileImage.forEach(item => {
							if(item.penaltiesImage != null) {
								data.push(item.penaltiesImage)
							}
						})
					}
				} else {
					if (this.certificateFileUrl != null && this.certificateFileUrl.length > 0) {
						this.certificateFileUrl.forEach(item => {
							data.push(item.certificateImage)
						})
					}
				}

				if (type == "type") { //点击【查看文书】按钮展示
					data = [];
					this.certificateFileUrl.forEach(item => {
						data.push(item.certificateImage)
					})
				}
				if (type == "preview") {
					data = [];
					data.push(url)
				}
				
				data = Array.from(new Set(data));
				let index = data.findIndex(item => item == url);
				let that = this;
				if (this.$store.state.previewImgUrl) {
					this.$store.commit("SHOW_PREVIEW_IMG", '')
				}
				setTimeout(() => {
					if (index > -1) {
						localStorage.setItem('myIndex', index);
						localStorage.setItem('myPics', JSON.stringify(data));
					} else {
						data.push(url);
						localStorage.setItem('myIndex', data.length - 1);
						localStorage.setItem('myPics', JSON.stringify(data));
					}
					localStorage.setItem('newDe', '');
					that.$store.commit("SHOW_PREVIEW_IMG", url);
				}, 500)
			},


			// ---------- old methods ----------

			// 案情暂存
			saveTemp(arg) {
				console.log("baseInfo", this.baseInfo)
				console.log("userInfos", this.userInfos)
				console.log("signParams", this.signParams)

				this.userInfos.carPlate = this.car_title + this.car_number;

				if(this.disabled_edit) return;
				// return;
				this.$axios.post(`/admin/enforcement/save`, {
					baseInfo: this.baseInfo,
					userInfos: [this.userInfos],
					clericalInfo: this.signParams,
				}).then(res => {
					console.log(res)
					let { code, data, msg } = res.data;
					if (code == 0) {
						if (arg == "no") {

						} else {
							this.$message.success("保存成功");
						}
					} else {
						this.$message.error(msg);
					}
				})
			},

			myLoopMethod() {
				let accidentId = this.roomId;
				this.$axios.get(`/admin/enforcement/record/${accidentId}/status`).then((res) => {
					let data = this.AppUtils.checkResponse(res);
					let status = data.data;
					if (res.data.code == 0) {
						this.remoteUserStatus = status.userOnline;
						// this.certificateFileUrl = status.certificateFileUrl ? JSON.parse(status.certificateFileUrl) : null;
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			deleteImg(index, ucode) {
				this.$axios.get(`/admin/enforcement/remove/penalties?uCode=${ucode}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.clericalFiles.splice(index, 1);
						this.$forceUpdate();
					}
				})
				this.is_scan = false;
			},

			doCancel(id, inde) {
				let accidentList = this.$store.state.myAccidentList;
				let index = inde;
				if (index > -1) {
					if (index == 0 && accidentList.length == 1) {
						this.closeMask();
						this.$store.commit('MyAccidentList', []);
						return false;
					}
					accidentList.splice(index, 1);
					this.$store.commit('MyAccidentList', accidentList);
					let ind = index - 1;
					if (ind < 0) {
						ind = 0;
					}
					this.reStartMask(accidentList[ind].id);
				}

			},
			reStartMask(id) {
				this.$emit('reStartMask', id)
			},

			setScrollTop(type) {
				let topValue;
				let topArray = [];
				if(type == 0) {
					topValue = 0;
				} else {
					for(let i = 0; i < type; i++) {
						topArray.push(document.getElementsByClassName('el-collapse')[i].clientHeight);
					}
					topValue = topArray.reduce((pre, val) => {
						return pre += val
					}, 0)
				}
				$('.leftContent').animate({
					scrollTop: topValue
				}, 500);
			},

			beforeunloadHandler(e) { //根据事件进行操作进行操作
				console.log(e)
				console.log('浏览器刷新')
				this.saveTemp();
			},

			switchLocalMain1(e) {
				this.myTempIndex = null;
			},

			goTop(userId, id) {
				let ind;
				let members = this.list;
				members.forEach((item, index) => {
					if (item.userId == userId) {
						ind = index;
					}
				})
				this.myTempIndex = ind
			},

			onChangeView() {
				let notDisplay = !this.isShowView;
				this.$axios.post(`/admin/accident/display/video`, {
					notDisplay: notDisplay
				}).then(res => {
					let { code, data } = res.data;
					if (code === 0) {
						let title = notDisplay ? "车主端已关闭警端视频" : "车主端已打开警端视频";
						this.$message.success(title);
						this.isShowView = !this.isShowView;
						sessionStorage.setItem('isShowView', this.isShowView)
					}
				})
			},

			getRoom() {
				var accidenId = this.roomId;
				this.$axios.post(`/admin/enforcement/${accidenId}/video/room/create`).then((res) => {
					let data = res.data;
					if (data.code === 0) {
						this.myTempIndex = 0;
						this.nowId = data.data;
						this.startJoinRoom();
						this.isAudio = true;
					} else {
						this.$message.error(data.msg);
					}
				})
			},

			kickPerson(userId) {
				let ind;
				let members = this.members_;
				let values = members.values();
				values = Array.from(values);
				let keys = members.keys();
				keys = Array.from(keys);
				values.forEach((item, index) => {
					if (item.getUserId() == userId) {
						ind = index;
					}
				})
				let that = this;
				let accidentId = this.roomId;
				let roomId = this.nowId;
				this.$axios.post(`/admin/accident/${accidentId}/video/room/${roomId}/remove/${userId} `).then(res => {
					let data = res.data;
					if (data.code === 0) {} else {
						this.$message.error(data.msg)
					}
				})
			},

			getStartMethods() {
				if (this.newStream) {
					this.leaveRoom();
				}
				clearInterval(this.userItemInterval);
				this.$emit("closeMask");
				this.$emit("startMethod");
			},

			async snapRemote(key, usePart, index) {
				if (!this.remoteUserStatus) {
					this.$message.error("报警人已退出");
					return false;
				}
				if (!this.newStream) {
					this.$message.error("截图失败,请检查视频是否接通!");
					return false;
				}
				this.tempKey = {
					key,
					usePart,
					index,
				}
				console.log(this.list)
				this.snapRemoteImg(this.list[0].userId).then((src) => {
					console.log("src", src)
					
				}).catch((err) => {
					this.$message.error(err);
				})
			},

			closeMask() {
				this.$emit("closeMask");
				this.leaveRoom();
				this.getStartMethods();
			},

			// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-* 音视频相关操作 start *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*

			notInRoom() {
				this.$message.error("预约人未在等待状态");
			},
			startJoinRoom() {
				if (!this.remoteUserStatus) {
					// return this.$message.error("报警人未在等待状态");
				}
				this.createClient(this.userId);
			},

			close() {
				this.isVedio = true;
				this.isAudio = true;
				this.isShow = false;
				this.$emit("close");
			},

			// 创建链接
			createClient(userId) {
				// 获取签名
				const config = this.genTestUserSig(userId);
				const sdkAppId = config.sdkAppId;
				const userSig = config.userSig;
				this.client = TRTC.createClient({
					mode: "rtc",
					sdkAppId,
					userId,
					userSig,
					useStringRoomId: true,//指定房间号为字符串；有roomType打开，没有roomType去掉
				});
				// 初始化后才能加入房间
				this.joinRoom();
			},
			// 加入房间
			async joinRoom() {
				console.log("this.nowId", this.nowId);
				await this.client
					.join({
						// roomId: Number(this.nowId),//没有roomType
						roomId: config.roomType + Number(this.nowId),//有roomType
					})
					.then(() => {
						// 创建本地流
						this.createStream();
						// 播放远端流
						this.playStream();
					})
					.catch((error) => {
						console.error("进房失败 " + error);
					})

				// 注册远程监听，要放在加入房间前--这里用了发布订阅模式
				this.subscribeStream();
			},
			// 创建本地音视频流
			createStream() {
				var _this = this;
				this.localStream = TRTC.createStream({
					userId: this.userId,
					audio: true,
					video: true,
				})
				this.localStream.setVideoProfile({
					width: 640,
					height: 640,
					frameRate: 24,
					bitrate: 600, /* kpbs */
				})
				this.localStream
					.initialize()
					.then(() => {
						console.log("初始化本地流成功")
						// 创建好后才能播放 本地流播放 local_stream 是div的id
						this.localStream.play("local_stream");
						this.$nextTick(() => {
							// 创建好后才能发布
							this.publishStream();
						});
						this.hasLocal = true;
						this.updateStream();
					})
					.catch((error) => {
						_this.AppUtils.alert("初始化本地流失败 " + error);
						_this.hasLocal = false;
						var accidentId = _this.roomId;
						var roomId = _this.nowId;
						_this.$axios.post(`/admin/accident/${accidentId}/video/room/dismiss/${roomId}`).then((res) => {
							let data = res.data;
							if (data.code === 0) {} else {
								_this.$message.error(data.msg);
							}
						})
					})
			},
			// 发布本地音视频流
			publishStream() {
				var _this = this;
				this.client
					.publish(this.localStream)
					.catch((error) => {
						_this.AppUtils.alert("本地流发布失败 " + error);
					})
					.then(() => {
						$("#local_stream").addClass("mainVedio").parent().addClass("active");
						console.log("本地流发布成功")
					})
			},
			// 远端监听
			updateStream() {
				var that = this;
				this.client.on("peer-leave", (event) => {
					console.log("远端关闭")
					that.hasLocal = false;
					// this.$message.error("报警人已挂断，请稍候");
					const userId = event.userId;
					let ind;
					ind = that.list.findIndex((v) => v.userId === userId);

					let obj = that.list[ind];
					let element = document.getElementById(obj.id);
					let parentNode = element.parentNode.parentNode;

					if (ind == 0) {
						let element = document.getElementById(obj.id);
						element.parentNode.parentNode.removeChild(element.parentNode);
					} else if (ind > 0) {
						let element = document.getElementById(obj.id);
						element.parentNode.parentNode.removeChild(element.parentNode);
					}

					if (parentNode.children.length == 2) {
						this.$message.error('已全部挂断');
						that.leaveRoom();
					}
					if (parentNode.children.length > 2) {
						this.$message.error('有人退出');
						this.myTempIndex = 0;
					}
					//8005
					that.list.splice(ind, 1);
					that.fullVideo = false;
				})
				this.client.on("stream-removed", (event) => {
					console.log('remove了')
					const remoteStream = event.stream;
				})
				// 关闭摄像头
				this.client.on("mute-video", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					if (streamId) {
						$("#mask_" + streamId).show();
					}
				})
				// 打开摄像头
				this.client.on("unmute-video", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					if (streamId) {
						$("#mask_" + streamId).hide();
					}
				})
				// 关闭语音
				this.client.on("mute-audio", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					$(`${"#user_" + streamId}`).find("#audio_" + streamId).hide().next().show();
				})
				// 打开语音
				this.client.on("unmute-audio", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					$(`${"#user_" + streamId}`).find("#unaudio_" + streamId).hide().prev().show();
				})
			},
			// 根据id获取uid
			getUidByStreamId(streamId) {
				for (let [uid, stream] of this.members_) {
					if (stream.getUserId() == streamId) {
						return uid;
					}
				}
			},
			// 订阅远端流--加入房间之前
			subscribeStream() {
				this.showPolice = true;
				let _this = this;
				this.client.on("stream-added", (event) => {
					const remoteStream = event.stream;
					this.isHave = false;
					for (let [uid, stream] of this.members_) {
						if (stream.getUserId() === remoteStream.getUserId()) {
							$("#user_" + stream.getId()).remove();
							this.members_.delete(stream.getId());
							this.isHave = true;
						}
					}
					remoteStream.isMute = true;
					remoteStream.muteMeVideo = () => {
						remoteStream.muteVideo();
					}
					remoteStream.getAdLevel = () => {
						return remoteStream.getAudioLevel();
					}
					remoteStream.stopVideo = () => {
						remoteStream.stop();
					}
					remoteStream.on('player-state-changed', event => {
						if (event.state === 'PAUSED') {

						}
					})
					remoteStream.snapRemoteImgMore = (remoteStreams, id) => {
						return new Promise((resolve, reject) => {
							_this.$nextTick(() => {
								const frame = remoteStreams.getVideoFrame();
								if (frame) {
									resolve(frame)
								} else {
									reject('无法获得截图数据')
								}
							})
						})
					}
					remoteStream.muteMeAudio = (id, phone) => {
						let res;
						let phoneKey = 'phone_' + phone;
						setTimeout(() => {
							if (!remoteStream.isMute) {
								let classMy = `#remote_stream-${id} .unMute`;
								$(classMy).attr("class", "mute");
								//8361
								res = remoteStream.muteAudio();
								_this.$message.info('该用户话筒已关闭，其他用户已听不到声音！');
								//8849
								_this.muteMeObj[phoneKey] = true;
							} else {
								let classMy = `#remote_stream-${id} .mute`;
								$(classMy).attr("class", "unMute");
								res = remoteStream.unmuteAudio();
								_this.muteMeObj[phoneKey] = false;
							}
						}, 0)
					}

					this.members_.set(remoteStream.getId(), remoteStream);
					// 订阅远端流
					this.client.subscribe(remoteStream);
				})
			},
			snapRemoteImg(videoUserId) {
				var _this = this;
				return new Promise((resolve, reject) => {
					let remoteStream;
					let id;
					let members = this.members_;
					let values = members.values();
					values = Array.from(values);
					let findMember = values.find(value => value.userId_ == videoUserId);
					remoteStream = findMember;
					id = findMember.id_;
					let stream = _this.list[0];
					_this.$nextTick(() => {
						const frame = remoteStream.getVideoFrame();
						if (frame) {
							resolve(frame);
						} else {
							reject("无法获得截图数据");
						}
					})
				})
			},
			snapRemoteImgMore(remoteStream, id) {
				let _this = this;
				return new Promise((resolve, reject) => {
					_this.$nextTick(() => {
						remoteStream.stop();
						remoteStream.play('remote_stream-' + id).then(() => {
							const frame = remoteStream.getVideoFrame();
							if (frame) {
								resolve(frame)
							} else {
								reject('无法获得截图数据')
							}
						})
					})
				})
			},
			muteMyVideo(id) {
				let stream = this.members_.get(id);
				stream.muteMeVideo();
			},
			muteMyAudio(id, phone) {
				let stream = this.members_.get(id);
				stream.isMute = !stream.isMute;
				this.members_.get(id, stream);
				stream.muteMeAudio(id, phone);
			},
			snapMyVideo(id) {
				let stream = this.members_.get(id);
				stream.snapRemoteImgMore(stream, id).then(data => {
					console.log('snap', data)
				})
			},
			stopMyVideo(id) {
				let stream = this.members_.get(id);
				// stream.stopVideo();
				this.client.unsubscribe(stream).catch(e => {
					console.error('failed to unsubscribe remoteStream')
				})
			},
			// 播放远端流
			playStream() {
				var that = this;
				this.client.on("stream-subscribed", async (event) => {
					this.videoBtnShow = false;
					const remoteStream = event.stream;
					let isMute = remoteStream.isMute;
					this.newStream = event.stream;
					// 创建远端流标签，因为id是动态的，所以动态创建，用了v-html
					const id = remoteStream.getId();
					const userId = remoteStream.getUserId();
					this.id = id;
					let myUsers = [];
					let findRes = myUsers.find(user => user.videoUserId == userId);
					let role;
					// let phone;
					let phone = this.userInfos.telephone;
					if (findRes) {
						phone = findRes.phone || findRes.driverContact;
					}
					let phoneKey = 'phone_' + phone;
					if (that.muteMeObj[phoneKey] == true || that.muteMeObj[phoneKey] == false) {
						isMute = !that.muteMeObj[phoneKey];
						remoteStream.isMute = isMute;
						if (isMute) {
							remoteStream.unmuteAudio();
						} else {
							remoteStream.muteAudio();
						}
					}

					let findMyIndex = this.list.findIndex((v) => v.userId === remoteStream.getUserId())
					if (findMyIndex == -1) {
						console.log('走这里吧1')
						console.log('1', this.list)
						let length = this.list.length;
						length += 1;
						let name;
						if (userId && userId.indexOf('a') == 0) {
							name = '120人员';
						} else {
							name = '当事人';
						}
						this.remoteStream = `<div id="${'remote_stream-' + id}" style="width:100%;height:100%;position:relative;" onClick="goTop('${userId}','${id}')">
                                <span class="leftSide" onClick="muteMyAudio('${id}','${phone}');event.cancelBubble = true;">
                                    <span class="${isMute?'unMute':'mute'}" style="cursor:pointer" ></span>
                                    <span class="role">${name}</span>
                                </span>
                                <span class="stop" style="cursor:pointer;display:none;" onClick="kickPerson('${userId}');event.cancelBubble =true;"></span>
                                <span class="phone" style="display:none;">${phone}</span>
                            </div>`;
						this.list.push({
							id,
							userId: remoteStream.getUserId(),
							remoteStream: this.remoteStream,
							origin: remoteStream,
						})
						if (this.list.length > 1) {
							$("#local_stream").removeClass('margin0');
						}
					} else {
						console.log('2', this.list)
						console.log('走这里吧2')
						let length = findMyIndex + 1;
						let name;
						if (userId && userId.indexOf('a') == 0) {
							name = '120人员';
						} else {
							name = '当事人';
						}
						this.remoteStream = `<div id="${'remote_stream-' + id}" style="width:100%;height:100%;position:relative;" onClick="goTop('${userId}','${id}')">
                                <span class="leftSide" onClick="muteMyAudio('${id}','${phone}');event.cancelBubble =true;">
                                    <span class="${isMute?'unMute':'mute'}" style="cursor:pointer" ></span>
                                    <span class="role">${name}</span>
                                </span>
                                <span class="stop" style="cursor:pointer;display:none;" onClick="kickPerson('${userId}');event.cancelBubble =true;"></span>
                                <span class="phone" style="display:none;">${phone}</span>
                            </div>`;
						this.list.splice(
							findMyIndex,
							1, {
								id,
								userId: remoteStream.getUserId(),
								remoteStream: this.remoteStream,
								origin: remoteStream,
							}
						)
						if (this.list.length > 1) {
							$("#local_stream").removeClass('margin0');
						}
					}
					// 做了dom操作 需要使用$nextTick(),否则找不到创建的标签无法进行播放
					this.$nextTick(() => {
						console.log('有木有')
						// 播放
						remoteStream.play("remote_stream-" + id).then(() => {

						});
						let audio = $("#audio").clone();
						audio.attr("id", "audio_" + id);
						audio.css({
							width: "14px",
							height: "21px",
							background: "none",
							"margin-left": "auto",
						});
						let unaudio = $("#unaudio").clone();
						unaudio.attr("id", "unaudio_" + id);
						unaudio.css({
							width: "14px",
							height: "21px",
							background: "none",
							"margin-left": "auto",
						});

						let mask = $("#mask").clone();
						mask.text("");
						mask.attr("id", "mask_" + id);
						mask.css({
							width: "100%",
							height: "100%",
							"text-align": "center",
							"z-index": "99",
						});
						mask.appendTo($("#player_" + id));
						mask.hide();
						$("#player_" + id).css('background', "#eee")
						$("#player_" + id).css('box-sizing', "border-box");
						$("#player_" + id).css('padding', "2px");
						let status = $("<div>", {
							id: "status_" + id,
						});
						status.css({
							width: "100%",
							height: "100%",
							"text-align": "center",
							color: "#fff",
							display: "flex",
							"align-items": "center",
							"justify-content": "center",
						});
						status.html("<span>已离开会议<span>");
						status.appendTo($("#player_" + id));
						status.hide();
						$("#player_" + id).css({
							position: "absolute",
							top: "0px"
						});
					})
				})
			},
			async closeRoom() {
				if (!this.localStream) {
					return;
				}
				console.log("关闭本地")
				this.newStream = null;
				this.videoBtnShow = true;
				await this.client.unpublish(this.localStream);
				this.localStream.stop();
				this.localStream.close();
				this.localStream = null;
				this.fullVideo = false;
				await this.client.leave();
			},
			// 获取用户签名--前端测试用
			genTestUserSig(userID) {
				const SDKAPPID = config.sdkappid;
				const EXPIRETIME = 604800;
				const SECRETKEY = config.SECRETKEY;
				if (SDKAPPID === "" || SECRETKEY === "") {
					return false;
				}
				const generator = new LibGenerateTestUserSig(
					SDKAPPID,
					SECRETKEY,
					EXPIRETIME
				)
				const userSig = generator.genTestUserSig(userID);
				return {
					sdkAppId: SDKAPPID,
					userSig: userSig,
				}
			},
			// 关闭/打开摄像头
			async muteLocalVideo() {
				if (this.isVedio) {
					this.isVedio = false;
					// this.localStream.muteVideo();
					const videoTrack = this.localStream.getVideoTrack();
					if (videoTrack) {
						await this.localStream.removeTrack(videoTrack)
						// 停止采集，关闭摄像头
						videoTrack.stop();
					}
				} else {
					this.isVedio = true;
					// this.localStream.unmuteVideo();
					const videoStream = TRTC.createStream({
						userId: this.userId,
						audio: false,
						video: true
					})
					await videoStream.initialize();
					await this.localStream.addTrack(videoStream.getVideoTrack());
				}
			},
			// 关闭/打开麦克风
			async muteLocalAudio() {
				if (this.isAudio) {
					this.isAudio = false;
					this.localStream.muteAudio();
					this.$message.info('该用户话筒已关闭，其他用户已听不到声音！');
					// const audioTrack = this.localStream.getAudioTrack();
					// if (audioTrack) {
					//     audioTrack.stop();
					// }
				} else {
					this.isAudio = true;
					let res = this.localStream.unmuteAudio();
					console.log("unmuteAudio", res)
					// await this.localStream.replaceTrack(this.localStream.getAudioTrack());
				}
			},
			leaveRoom() {
				this.videoBtnShow = true;
				this.showPolice = false;
				this.remoteStatus == 'danger';
				this.list = [];
				this.muteMeObj = {};
				this.hasLocal = false;
				this.closeRoom();
			},

			// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-* 音视频相关操作 end *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*

		},
	}
</script>

<style lang="less" scoped>
	.main {
		display: flex;
		background: #fff;
		flex-direction: row;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		overflow-y: hidden;
		z-index: 100;
		flex-direction: column;
		box-sizing: border-box;
		padding-top: 3px;
		padding-left: 10px;
	}

	.leftContent {
		overflow-x: hidden;
		height: calc(100% - 50px);
		overflow-y: scroll;
		box-sizing: border-box;
		text-align: left;
		margin-right: 10px;
		float: left;

		.tableContent {
			margin-top: 10px;
			border: 1px solid #f4f5f7;
			flex: 3;
		}
	}

	.rightContent {
		width: 471px;
		// height: 100%;
		height: calc(100% - 90px);
		display: flex;
		position: fixed;
		top: 53px;
		right: 2px;
		float: right;

		.left {
			width: 100%;
			box-sizing: border-box;
			display: flex;
			overflow-y: auto;
			background: #eee;
			align-content: flex-start;
			margin-bottom: 10px;
			flex-wrap: nowrap;
			flex-direction: column;

			.userlist {
				width: 190px;
				height: 150px;
				border-radius: 1px;
				margin-top: 10px;
				position: static;
				display: flex;
				flex-direction: column;
				margin-top: auto;
				background-position: center 0px;
				background-size: 100%;
				position: relative;
				margin-left: 0px;

				&:nth-child(2n) {
					margin-left: 0px;
				}

				p {
					color: #fff;
					font-size: 14px;
					text-align: center;
				}

				.img {
					width: 100%;
					height: 130px;
					background: #fff;
				}
			}

			.remoteClass {
				width: 100%;
				height: 122px;
				margin-top: 0px !important;
				border: none !important;
			}

			.fullRemoteClass {
				width: 100% !important;
				margin-top: 25px;
				border: none !important;
			}
		}

		.right {
			width: calc(100vw - 210px);
			height: calc(100vh - 69px);
			background-color: #3d3b3b;
			border-radius: 1px;
			margin: 0 10px 10px 10px;
			padding: 0 10px;

			.container {
				width: 100%;
				height: 820px;
				background: #191f24;
			}

			.maskshow {
				display: block;
			}

			.operator {
				display: flex;
				justify-content: center;
				margin-top: 20px;
				text-align: center;
				position: absolute;
				bottom: 40px;
				left: 50%;

				.item {
					display: flex;
					flex-direction: column;
					width: 80px;

					&:nth-child(1) .img-warp .img {
						width: 23px;
					}

					&:nth-child(2) .img-warp .img {
						width: 40px;
					}

					&:nth-child(3) .img-warp {
						background: #e63517;

						.img {
							width: 44px;
						}
					}

					.img-warp {
						width: 100%;
						height: 45px;
						text-align: center;
						line-height: 45px;
						background: #e3e3e3;
						border-radius: 10px;
						position: relative;

						.img {
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}

					&:not(:first-child) {
						margin-left: 20px;
					}

					.item-icon {
						width: 80px;
						height: 45px;
						line-height: 45px;
						background-color: #e3e3e3;
						border-radius: 10px;
					}

					span {
						font-size: 16px;
						text-align: center;
						color: #fff;
						margin-top: 10px;
					}
				}
			}
		}
	}

	.distant-stream {
		width: 100%;
		height: 100%;
	}

	#local_stream {
		width: 100%;
		height: 100%;
	}

	.mainVedio {
		position: absolute;
		z-index: 110;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding-left: 2px;
		padding-right: 2px;
		padding-bottom: 2px;
	}

	#warp {
		display: flex;
		flex-direction: column;
	}

	.maskable {
		position: absolute;
		width: calc(100% - 386px);
		right: 0px;
		height: 80%;
		color: #fff;
		text-align: center;
		line-height: 900px;
		background: url(../../../static/images/08摄像头已关闭@2x.png) center no-repeat;
	}

	.wholeAcccindentClass {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;

		.accidentImages {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-flow: wrap;

			.images {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: column;
				height: 200px;
				margin: 10px;

				.img-box {
					width: 200px;
					margin: 0 auto;
					// border: 5px solid #409EFF;
				}
			}
		}
	}

	.bottomBtns {
		width: 100%;
		position: fixed;
		left: 0px;
		bottom: 0px;
		background: #ccc;
		margin-bottom: 0px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.hang_up_btn {
		width: 40px;
		height: 40px;
		margin-left: 150px;
	}
	.hang_up_btn img {
		width: 100%;
		height: 100%;
	}

	.original_left {
		width: calc(100% - 473px);
	}

	.fullVideoClass_left {
		width: calc(100% - 610px) !important;
	}

	.fullVideoClass_right {
		max-width: 600px !important;
		min-width: 600px !important;
	}

	.myBtn {
		padding: 12px 16px !important;
		color: #000;
		cursor: pointer;

		img {
			width: 50px;
			height: 50px;
			margin-bottom: 10px
		}
		.jt {
			background: #409EFF;
    		border-radius: 50%;
			border: 1px solid #409EFF;
    		box-sizing: border-box;
		}
	}

	.myMainVideo {
		width: 100% !important;
		height: 476px !important;
		margin: 0 auto !important;
		position: absolute !important;
		top: 2px;
		left: 50%;
		margin-left: -50% !important;
	}

	.myIcon {
		width: 28px;
		height: 28px;
		position: absolute;
		right: 3px;
		top: 3px;
		z-index: 99999;
		cursor: pointer;
	}

	.fullVideoClass_right {
		height: 88%;
		overflow: scroll;
	}

	.fullVideoClass_right .left .user,
	.fullVideoClass_right .left .police {
		height: 200px !important;
		width: 200px !important;
	}

	.fullVideoClass_right .myMainVideo {
		height: 600px !important;
	}

	.close_img {
		width: 14px;
		height: 14px;
		margin-left: 7px;
	}

	.jumpBtn {
		position: absolute;
		right: 476px;
		height: 30px;
		display: flex;

		.myJumpBtn {
			box-sizing: border-box;
			padding: 0px 5px;
			font-size: 12px;
			border: 1px solid #409eff;
			border-radius: 4px;
			margin-right: 10px;
			line-height: 28px;
			background: #409eff;
			color: #fff;
			cursor: pointer;
		}
	}

	.crumb {
		margin: 6px;

		.crumb_item {
			box-sizing: border-box;
			cursor: pointer;
			padding: 5px 10px !important;
		}
	}

	.activeCrumb {
		color: #1728d5;
		font-weight: bold;
	}

	.main /deep/ input::-webkit-outer-spin-button,
	.main /deep/ input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	// .main /deep/ input[type="number"] {
	//     -moz-appearance: textfield;
	// }

	.big_case {
		width: 96%;
		margin: 0 auto;
		display: flex;
		border-bottom: 1px solid #ededed
	}

	.ul_case {
		width: 80%;
		margin: 0px auto;
		padding: 10px;
	}

	.ul_case li {
		display: flex;
		margin: 5px 0;
	}

	.ul_contor {
		width: 10%;
		padding: 10px;
	}

	.ul_contor li {
		height: 30px;
		// margin: 10px 0;
		display: flex;
		// align-items: center;
		// justify-content: center;
	}

	.ul_contor li i {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 23px;
		color: #409EFF;
		cursor: pointer;
	}

	.big_case .ul_contor .ul_li_btn {
		width: 100px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		display: block;
		background: #409EFF;
		color: #fff;
		cursor: pointer;
	}

	.retrun_case {
		display: flex;
		flex-flow: wrap;
	}

	.retrun_image {
		width: 200px;
		height: 200px;
		margin: 10px 5px;
		display: block;
		cursor: pointer;
	}

	.rotate_image {
		transform: rotate(0deg);
	}

	.icon_address {
		width: 22px;
		height: 26px;
		display: inline-block;
		background: url("../../assets/images/pics/icon_adress.png") no-repeat center;
		background-size: 22px 26px;
		cursor: pointer;
	}

	.bf_btn {
		background: #264977;
		color: #fff;
	}
	.bf_active {
		border: 5px solid #264977!important;
	}

</style>


// WEBPACK FOOTER //
// video.vue?2a8f6415